import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { ReactComponent as Edit } from 'style/icons/edit.svg';
import './ExternallyCollapsibleHeader.scss';

const ExternallyCollapsibleHeader = function ({
  datatestid,
  headerText,
  isExpanded,
  expandCallback,
  editButtonText,
  ...props
}) {
  let expandButtonText = editButtonText ? editButtonText : 'Edit';
  return (
    <FlexContainer className="flex-row justify-between pad16 items-align-center externallyCollapsibleHeader">
      <Label datatestid={`${datatestid}-header`} type="H3" typeHeader={'h3'}>
        {headerText}
      </Label>
      {!isExpanded && (
        <>
          <Label
            datatestid={`${datatestid}-expandText`}
            onClick={expandCallback}
            type="Body-2 link mobileHide"
          >
            {expandButtonText}
          </Label>
          <Edit
            onClick={expandCallback}
            className="desktopHide"
            aria-label={'edit'}
          />
        </>
      )}
    </FlexContainer>
  );
};

export default ExternallyCollapsibleHeader;
